import * as S from './PromoCodeSelector.styles'
import { translateManager as t } from '../../../services/TranslateManager'
import useScreenSize from 'hooks/useScreenSize'

interface TopBarSectionProps {
  onDismiss: () => void
  onDone: () => void
}

function TopBarSection({ onDismiss, onDone }: TopBarSectionProps) {
  const isSmallScreen = useScreenSize('sm')
  return (
    <S.TopBar>
      {isSmallScreen && <S.CloseButton onClick={onDismiss} />}
      <S.Title>{t.get('general.menu.promo_code_manager.promo_codes')}</S.Title>
      <S.DoneButton onClick={onDone} data-testid="promo-code-done-button">
        {t.get('general.done')}
      </S.DoneButton>
    </S.TopBar>
  )
}

export default TopBarSection
